import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const AutoSaveIndicator = ({ 
  isAuthenticated,
  lastSaved,
  isSaving = false,
  hasUnsavedChanges = false,
  className = ''
}) => {
  const [showSaveStatus, setShowSaveStatus] = useState(false);

  useEffect(() => {
    if (isSaving || lastSaved) {
      setShowSaveStatus(true);
      const timer = setTimeout(() => {
        setShowSaveStatus(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSaving, lastSaved]);

  if (!isAuthenticated) {
    return (
      <div className={`flex items-center space-x-2 text-sm text-muted-foreground ${className}`}>
        <Icon name="AlertTriangle" size={16} className="text-warning" />
        <span>Sign in to save your progress</span>
      </div>
    );
  }

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const now = new Date();
    const saved = new Date(timestamp);
    const diffInSeconds = Math.floor((now - saved) / 1000);
    
    if (diffInSeconds < 60) {
      return 'just now';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    } else {
      return saved?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
  };

  return (
    <div className={`transition-all duration-300 ${showSaveStatus ? 'opacity-100' : 'opacity-60'} ${className}`}>
      {isSaving ? (
        <div className="flex items-center space-x-2 text-sm text-primary">
          <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          <span>Saving...</span>
        </div>
      ) : hasUnsavedChanges ? (
        <div className="flex items-center space-x-2 text-sm text-warning">
          <Icon name="Clock" size={16} />
          <span>Unsaved changes</span>
        </div>
      ) : lastSaved ? (
        <div className="flex items-center space-x-2 text-sm text-success">
          <Icon name="CheckCircle" size={16} />
          <span>Saved {formatTime(lastSaved)}</span>
        </div>
      ) : null}
    </div>
  );
};

export default AutoSaveIndicator;